<template>
  <div class="eval bg-white fs-xl">
    <div class="eval-content container">
      <div class="page-padding" />
      <el-skeleton :rows="14" animated v-if="loading" />
      <div class="eval-content-box bg-white-1 container-content mb-4" v-else>
        <!-- 科技量值(STEM) -->
        <div class="mb-10">
          <div class="pb-6">
            <img :src="hIcon" alt="" srcset="" width="45" class="v-a-b" />
            <span class="fs-large shadow-text text-primary-sub fw-600 item-ti">
              科技量值(STEM)
            </span>
          </div>
          <div class="item-desc">
            在中国医学科学院指导下，中国医学科学院医学信息研究所以完善医学科技评价体系，助力医学科技创新发展为宗旨，创新性应用评价理论和方法，构建多元长效的分类评价体系。
          </div>
          <div class="item-desc">
            科技量值(Science and Technology Evaluation
            Metrics，STEM)概念于2018年首次提出，它是围绕科技活动全过程，覆盖创新活动全链条的综合测算值，是国家衡量医学科技进步的标尺，是机构衡量自身科技发展水平的量尺，代表机构科技综合实力水平，是机构科技创新和可持续发展能力的体现。
          </div>
        </div>
        <!-- 中国医院科技量值(STEM) -->
        <div class="mb-8">
          <div class="pb-4">
            <span :class="['item-ti', 'fs-xxxxl', ...tiClassNames]">
              中国医院科技量值(STEM)
            </span>
          </div>
          <div class="item-desc">
            中国医院科技评价结果于2014-2024年连续十一年发布，受到社会广泛关注，人民网、新华网等多家主流媒体对此做了专题报道。项目组以国家科技政策为导向，汇集各界对评价方案和评价结果的意见和建议，不断优化和细化评价体系。2023年度中国医院STEM沿用统一标准、统一来源、统一方法，从科技产出、学术影响和科技条件三个维度构建评价体系，其中，科技产出维度包括期刊论文、专利和标准以及论文引用等方面；学术影响维度包括科技奖励以及学术任职等方面；科技条件维度包括科研项目和科研平台等方面。共对我国2943家三级医院开展研究，评价结果分为两部分，一是综合科技量值；二是学科科技量值，涵盖心血管病学、呼吸病学等共34个临床医学二级学科及部分三级学科。
          </div>
        </div>
        <!-- 中国医学院校科技量值(STEM) -->
        <div class="">
          <div class="pb-4">
            <!-- <img :src="hIcon" alt="" srcset="" width="32" class="v-a-b" /> -->
            <span :class="['item-ti', 'fs-xxxxl', ...tiClassNames]">
              中国医学院校科技量值(STEM)
            </span>
          </div>
          <div class="item-desc">
            在科学知识创新和发展驱动下，世界一流水平大学建设已成为世界各国及其高等教育体系的工作重点。医学是我国学科体系的重要组成部分，医学科技评价是推动医学创新驱动发展的一项基础性工作，应根据高校发展特点，建立中国特色的评价体系。2019年，项目组首次探索医学院校STEM研究，以期基于评价活动引领医学院校学科发展，助力医学科技创新。中国医学院校STEM参照医院STEM多维评价体系构建，同时结合医学院校学科建设与研究实际，纳入教育部工程研究中心、教育部国际合作联合实验室、高等学校科学研究优秀成果奖等可反映医学院校科技活动特点的指标，2023年度共对我国110所具有医学类相关专业研究生招生资格的独立医学院校以及设置医学相关学科的综合性大学开展研究。
          </div>
        </div>
      </div>
      <div class="eval-content-box bg-white-1 container-content mb-4">
        <!-- 五年总科技量值(ASTEM) -->
        <div class="">
          <div class="pb-6">
            <img :src="hIcon" alt="" srcset="" width="45" class="v-a-b" />
            <span class="fs-large shadow-text text-primary-sub fw-600 item-ti">
              五年总科技量值(ASTEM)
            </span>
          </div>
          <div class="item-desc">
            总科技量值(Accumulative Science and Technology Evaluation
            Metrics，ASTEM)概念由2022年首次提出，是以STEM为基础衍生的，用于长周期评价的综合测算值。
          </div>
          <div class="item-desc">
            目前，中国医院科技量值已成为引导医学科技创新的重要工具，在国内医学科技评价领域起到领跑作用，在医学界产生广泛影响。中国医学院校/医院五年总科技量值(ASTEM)，其目的是考虑到科学研究不是一蹴而就，高质量科技成果依赖于时间积淀，科研项目资助存在“大小年”现象，同时科学研究具有长期性和周期性特点，通过五年评价能更好反映机构长期稳定的科研实力。五年体系的演进与国家评价导向和学界共识一致，五年总科技量值是基于最新指标体系和五年数据积累测算的结果。年度评价和五年评价可以平衡评价时效与科研周期之间的矛盾。年度评价作为科研管理的重要工具，可以有效督促医院开展科学研究。五年评价能更好反映医院学科建设在长周期内的真实水平及稳定的科技实力。
          </div>
        </div>
      </div>
      <!-- 评价方法 -->
      <div class="eval-content-box bg-white-1 container-content">
        <!-- <ListCard class="pt-8 pb-10" /> -->
        <div class="mb-8">
          <div class="pb-6">
            <img :src="hIcon" alt="" srcset="" width="45" class="v-a-b" />
            <span class="fs-large shadow-text text-primary-sub fw-600 item-ti">
              评价方法
            </span>
          </div>
          <div class="item-desc">
            为保证评价的科学性和准确性，本研究立足当前实际应用，以“科学、客观、缜密、公平”为原则，创新性应用评价理论和方法，通过文献调研和专家咨询，借鉴国内外科技评价经验并结合医院、医学院校实际，构建中国医院和医学院校科技量值评价指标体系。具体评价过程如下:
            通过文献分析，广泛借鉴国内外相关科技评价指标，初步构建中国医院及医学院校科技量值评价基本指标框架；利用专家咨询法对基本指标框架进行充分论证；通过德尔菲法分析指标设置合理性、指标定义准确性等，从重要性和可操作性两方面确定评价指标体系；采用层次分析法确定指标权重；根据评价指标的类型，采用极值标准化法对其进行标准化处理，将评价指标的标准化值与相应指标权重系数的乘积相加，以百分制形式计算每家医院、医学院校的科技量值。
          </div>
          <div class="item-desc">
            医院、医学院校综合量值根据每家医院、医学院校的全部指标数据加权计算；医院学科量值先将每家医院数据标引到各学科，再将各学科数据加权计算。
          </div>
          <div class="item-desc">
            中国医院STEM和医学院校STEM对医院和医学院校的科技创新力进行评价，特点主要体现在聚焦科技综合实力、突出医学特征、注重研究质量及影响、强调成果转化、鼓励科研合作，以及倡导科研诚信等方面，希望对中国医学科技发展起到一定的导引作用，为推动一流学科建设，促进医学科技成果向应用转化提供有力的科技支撑。
          </div>
        </div>
      </div>
      <div class="page-padding" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import hIcon from '@/assets/icons/hospital.png'
import { setPV } from '@/api/config.js'

const tiClassNames = ['text-primary-sub fw-600 fs-xxxl mb-3 shadow-text']
const loading = ref(true)

onMounted(async () => {
  loading.value = false
  await setPV()
})
</script>

<style lang="scss" scoped>
.eval {
  .bg-gray {
    background: #f2f2f2;
  }
  &-content {
    &-box {
      .item {
        &-ti {
          letter-spacing: 0.0625rem;
        }
        &-desc {
          line-height: 1.8;
          text-indent: 2em;
          text-align: justify;
        }
      }
    }
  }
}
</style>
